import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import {
  PageBar,
  SSPCommonButton,
  SSPCommonVideo,
  SSPCommonTable,
} from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { Download } from "@mui/icons-material";
import AWS from "aws-sdk";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Modal,
  IconButton,
  Link,
  TextField,
} from "@mui/material";
import clsx from "clsx";
import { functionURLService } from "../../Components/functionalurl";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import styled from "styled-components";
import * as FileSaver from "file-saver";
import { post } from "../../services";
import Cookies from "js-cookie";
import { isDevelopment } from "../../Hooks/constants";

const ISP_Status = ({ token }) => {
  const id = Cookies.get("ssp_domain_id");

  // Dynamic Base URL based on Environment Variables
  const base = isDevelopment
    ? `${process.env.REACT_APP_MDM_DEV || process.env.REACT_APP_SSP_MDM_DEV}`
    : `${process.env.REACT_APP_MDM_PROD || process.env.REACT_APP_SSP_MDM_PROD}`;
  const boxSX = {
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      color: "darkblue",
    },
  };

  // const { id,token } = useParams();s
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [rows, setRows] = useState([]);
  const [originalRowsData, setOriginalRowsData] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [loc, setLoc] = useState("");

  const rowFetch = async () => {
    setLoading(true);
    setmessage("Fetching Data");
    try {
      let response = await post(
        base,
        {
          action: "status",
          loc: parseInt(loc),
          rawPath: "/isp_status",
        },
        true,
        false
      );
      if (response && response?.data && Array.isArray(response?.data)) {
        const rowsData = response?.data.map((row, index) => ({
          ...row,
          id: index + 1,
        }));
        setOriginalRowsData(rowsData);
        setRows(rowsData);
      } else {
        setmessage("Invalid location or location not updated in master yet");
        setmodalOpener(true);
      }
    } catch (error) {
      setmessage("Error fetching data");
      setmodalOpener(true);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //     rowFetch();
  // }, []);

  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };

  const downloadProgressFile = async (logId) => {
    let response = await post(
      base,
      {
        log_id: logId,
        rawPath: "/process_log",
      },
      true,
      false
    );
    let data1 = response?.body.message.map((obj) => ({
      error_message: obj.error_message,
      log_id: obj.log_id,
      item: obj.item,
      dc_city: obj.dc_city,
      supplier: obj.supplier,
      target_base: obj.target_base,
      target_type: obj.target_type,
      target_value: obj.target_value,
      target_achieve_perc: obj.target_achieve_perc,
      target_perc: obj.target_perc,
      period_type: obj.period_type,
      start_date: obj.start_date,
      end_date: obj.end_date,
      cal_type: obj.cal_type,
      status: obj.status,
    }));
    DownloadExcelSheet(data1, "mdm_target");
  };
  const ExcelJS = require("exceljs");
  const DownloadExcelSheet = async (response, fileName) => {
    if (response !== null) {
      let data = response;
      const workbook = new ExcelJS.Workbook();
      const headers = Object.keys(data[0]);
      const worksheet = workbook.addWorksheet("data");
      const firstRow = worksheet.getRow(1);
      for (let i = 1; i <= headers?.length; i++) {
        const cell = firstRow.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFA500" },
        };
      }
      worksheet.columns = headers.map((header) => ({ header, key: header }));
      data.forEach((dataRow) => {
        worksheet.addRow(dataRow);
      });
      worksheet.columns.forEach((column) => {
        column.width = 25;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
      });
    } else {
      setmessage("No data provided to download the file");
      setmodalOpener(true);
    }
  };
  const handleDownloadSampleFile = async () => {
    let response = await post(
      base,
      {
        action: "isp_master",
        rawPath: "/isp_status",
      },
      true,
      false
    );
    let data1 = response?.data.map((obj) => ({
      loc: obj.loc,
      loc_name: obj.loc_name,
      region: obj.region,
      subnet: obj.subnet,
      gateway_ip: obj.gateway_ip,
      isp_1: obj.isp_1,
      isp_2: obj.isp_2,
      isp1_link_type: obj.isp1_link_type,
      isp2_link_type: obj.isp2_link_type,
      vendor: obj.vendor,
    }));
    DownloadExcelSheet(data1, "isp_master");
  };

  const columns = [
    { field: "id", headerName: "Sr.no", flex: 0.5 },
    { field: "loc", headerName: "Location", flex: 0.7 },
    {
      field: "loc_name",
      headerName: "Location Name",
      flex: 2,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    { field: "gateway_ip", headerName: "Gateway IP", flex: 1 },
    { field: "vendor", headerName: "Vendor", flex: 1 },

    {
      field: "isp_1",
      headerName: "ISP1",
      flex: 0.8,
    },
    {
      field: "isp_2",
      headerName: "ISP2",
      flex: 0.8,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "formatted_date",
      headerName: "Date",
      flex: 0.8,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          progressdata: params.value === "Customer Order Created",
          progressdatafail: params.value === "Customer Order Creation Failed",
        });
      },
    },
    {
      field: "formatted_time",
      headerName: "Time",
      type: "number",
      flex: 0.7,
      wrapText: true,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ip_avl",
      headerName: "Availability",
      type: "number",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const value = params.value;
        return (
          <div
            style={{ width: "100%", fontWeight: "bold", textAlign: "center" }}
          >
            {value === "Y" ? (
              <span style={{ color: "grey" }}>Available</span>
            ) : value === "C" ? (
              <span style={{ color: "red" }}>Not Reachable</span>
            ) : value === "W" ? (
              <span style={{ color: "#FF7A57" }}>Weak</span>
            ) : (
              <span>{value}</span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
        }}
      >
        {/* Page Bar */}
        <PageBar
          text="IT Infrastructure : ISP Status"
          vendorId={id}
          vendorName={vendorName}
        />

        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={"Search by Loc"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
              fontSize: 15,
              // marginBottom: -5
            }}
          >
            <Grid container Spacing={2}>
              <Box
                p={2}
                sx={{
                  display: { lg: "flex", md: "flex" },
                  gap: "1rem",
                }}
              >
                <Typography sx={{ marginTop: 1 }}>
                  Enter Location Code :
                </Typography>
                <TextField
                  rows={1}
                  variant="outlined"
                  label="Enter Location Code"
                  value={loc}
                  size="small"
                  onChange={(e) => setLoc(e.target.value)}
                />
              </Box>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                lg={3}
                sx={{ marginTop: 2, marginBottom: 1 }}
              >
                <SSPCommonButton
                  btnText={"Check Status"}
                  btnFunction={rowFetch}
                  loading={loading}
                  loadingText="Searching..."
                />
              </Grid>
              <Link
                component={"button"}
                color={"#0160F1"}
                sx={boxSX}
                onClick={handleDownloadSampleFile}
              >
                {"Download ISP Master"}
              </Link>
            </Grid>
            <Box
              p={1}
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "16px",
                marginLeft: "1rem",
              }}
            ></Box>
          </CardContent>
        </Card>

        {/* Table  */}
        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={"ISP Status in past 48 hours"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
            action={
              <>
                <Button onClick={() => window.location.reload()}>
                  Refresh Page
                </Button>
              </>
            }
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          >
            <Box
              sx={{
                height: 700,
                width: "100%",
                "& .super-app.positive": {
                  color: "rgb(4,171,105)",

                  fontWeight: "600",
                },
                "& .super-app.negative": {
                  color: "rgb(234,39,21)",

                  fontWeight: "600",
                },
                "& .super-app.partial": {
                  color: "rgb(244,161,0)",

                  fontWeight: "600",
                },
                "& .super-app.progressdata": {
                  color: "rgb(4,171,105)",

                  fontWeight: "600",
                },
                "& .super-app.progressdatafail": {
                  color: "rgb(234,39,21)",

                  fontWeight: "600",
                },

                "& .super-app.processing": {
                  color: "rgb(104,112,122)",

                  fontWeight: "600",
                },
                "& .super-app.pending": {
                  color: "rgb(3,95,240)",

                  fontWeight: "600",
                },
              }}
            >
              <DataGrid
                // disableColumnMenu={true}
                rowHeight={65}
                showCellRightBorder={true}
                sx={{
                  ".MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold !important",
                  },
                  overflowX: "scroll",
                }}
                rows={rows}
                columns={columns}
                headerClassName="header-center"
                rowsPerPageOptions={[10]}
                pageSize={10}
                getRowId={(row) => row.id}
                components={{
                  Toolbar: GridToolbar,
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
        <SSPCommonVideo
          headerText={"Demo Video"}
          videoUrl={
            "https://www.youtube.com/embed/uEC1wwmG8dE?si=zrEZ05FUyJ42VtfZ"
          }
        />
        {modalOpener && (
          <SSPCommonModal
            open={modalOpener}
            handleOpenClose={setmodalOpener}
            message={message}
          />
        )}
      </Box>
    </>
  );
};
export default ISP_Status;
